import { render, staticRenderFns } from "./InternalDb.vue?vue&type=template&id=7942e395"
import script from "./InternalDb.vue?vue&type=script&lang=js"
export * from "./InternalDb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports